import Service 			from "./../../Libs/Service";
import _ 				from "lodash";

let Metadata = new Service({

	Name: "Metadata",

	Events: {

	},

	Actions: {

		//Получение метаданных из БД
		"Metadata": function(metadata) {

			_.extend(this, metadata);

			document.title = 'MPG Campaign Tracking Dashboard';

			this.loaded = true;

			Broadcast.call("Metadata Loaded");

		}

	},

	init() {

		this.loaded = false;

		this.Config = {};

	}

});

//Только для наблюдения за состоянием через консоль браузера
window.Metadata = Metadata;

export { Metadata };

